export const paths = {
  index: '/',
  notFound: '/404',
  auth: {
    signIn: '/login',
    mfa: '/login/mfa',
    signUp: '/register',
    forgotPassword: '/forgot-password',
    resetPassword: '/reset-password',
    logout: '/logout',
    switch: '/switch',
    oAuth: {
      google: 'connect/google',
      github: 'connect/github',
    },
  },
  marketplace: {
    index: '/marketplace',
  },
  order: {
    index: '/order',
    proxy: '/order/proxy',
    details: '/order/details',
    checkout: '/order/checkout',
  },
  organizations: {
    create: '/organizations/new',
    manage: (id = ':id') => `/organizations/${id}`,
  },
  account: {
    index: '/account',
    general: '/account/general',
    notifications: '/account/notifications',
    security: '/account/security',
    identityVerification: '/account/id-verification',
    payments: '/account/billing',
  },
  payments: {
    callback: '/payments/callback',
  },
  proxies: {
    index: '/proxies',
    active: '/proxies?preset=active',
    inactive: '/proxies?preset=inactive',
    expiring: '/proxies?preset=expiring',
    replace: '/proxies/replace',
    operation: {
      index: '/proxies/operation',
      id: (operationId: string) => `/proxies/operation/${operationId}`,
    },
    overview: (proxyId: string | number) => `/proxies/${proxyId}`,
    credentialsGenerator: (proxyId: number) => `/proxies/${proxyId}/credentials-generator`,
  },
  referrals: {
    index: '/referrals',
    bank: '/referrals/bank',
  },
  featureRequest: {
    index: '/feature-request',
  },
  reseller: {
    index: '/reseller',
  },
  apiKeys: {
    index: '/api-keys',
  },
  webhooks: {
    index: '/webhooks',
    details: (id = ':webhookId') => `/webhooks/${id}`,
  },
  external: {
    asnLookup: 'https://asnlookup.com',
    needHelp: 'https://support.proxy-cheap.com/hc/en-us/categories/24603913038237-Getting-Started',
    faq: 'https://support.proxy-cheap.com/hc/en-us/articles/38182068823837-Proxy-Cheap-Frequently-Asked-Questions',
    whatIsMyIp: 'https://www.maxmind.com/en/geoip-web-services-demo',
    apiDocumentation: 'https://docs.proxy-cheap.com/',
    webhooksDocumentation: 'https://docs.proxy-cheap.com/#5f9bf592-563e-47bc-b3b1-ff956454301c',
    termsAndConditions: 'https://www.proxy-cheap.com/terms-and-conditions',
    privacyPolicy: 'https://www.proxy-cheap.com/privacy-policy',
    stripe: 'https://www.stripe.com',
    whmcs: 'https://marketplace.whmcs.com/product/6889-whitelabel-proxy-reseller-module',
    extensions: {
      chrome: 'https://chrome.google.com/webstore/detail/proxy-cheap-proxy-manager/gdpehpfhegefkjelaifkdbppjbhilaom',
      firefox: 'https://addons.mozilla.org/en-US/firefox/addon/proxy-cheap-proxy-manager/',
      'vpn-cheap': 'https://vpn-cheap.com/',
    },
    trustpilotReview: 'https://www.trustpilot.com/evaluate/proxy-cheap.com',
    services: {
      'static-residential-ipv4': 'https://support.proxy-cheap.com/hc/en-us',
      'static-residential-ipv6': 'https://support.proxy-cheap.com/hc/en-us',
      'static-datacenter-ipv4': 'https://support.proxy-cheap.com/hc/en-us',
      'static-datacenter-ipv6': 'https://support.proxy-cheap.com/hc/en-us',
      'rotating-residential': 'https://support.proxy-cheap.com/hc/en-us',
      'rotating-mobile': 'https://support.proxy-cheap.com/hc/en-us',
      'dedicated-mobile': 'https://support.proxy-cheap.com/hc/en-us',
      vpn: 'https://support.proxy-cheap.com/hc/en-us',
    },
    testIPv6: 'https://dnschecker.org/ipv6-compatibility-checker.php',
    gettingStarted: 'https://support.proxy-cheap.com/hc/en-us/categories/24603913038237-Getting-Started',
    tutorials: 'https://support.proxy-cheap.com/hc/en-us/categories/24603912883997-Proxy-Setup-Configuration',
    faqs: 'https://support.proxy-cheap.com/hc/en-us/categories/23303038105501-Troubleshooting-Support',
    widget: {
      docs: 'https://support.proxy-cheap.com/hc/en-us/articles/25206969256477-Integrating-and-Customizing-the-Proxy-Cheap-Widget-on-Your-Website',
      example: 'https://codesandbox.io/p/sandbox/xx54q3',
    },
  },
};
